import { defineMessages } from 'react-intl';

export default defineMessages({
    doingRateMessage: {
        id: 'endorsement.eh.views.riskAnalysis.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    lossesAndViolationTabHeading: {
        id: 'endorsement.eh.views.riskAnalysis.lossesAndViolation.Losses',
        defaultMessage: 'Losses'
    },
    miscellaneaousReportsTabHeading: {
        id: 'endorsement.eh.views.riskAnalysis.miscellaneaousReports.Miscellaneous Reports',
        defaultMessage: 'Miscellaneous Reports'
    },
    creditTabHeading: {
        id: 'endorsement.eh.views.riskAnalysis.credit.Credit',
        defaultMessage: 'Credit'
    }
});
